(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tizz-social-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Map of initialised walls → their Embla instance. Lets us destroy
    // the old instance before re-init on shopify:section:load (editor
    // live preview), avoiding listener leaks.
    const instances = new WeakMap();

    function ready(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn, { once: true });
      } else {
        fn();
      }
    }

    // ~2s at 60fps. Defer ordering already puts embla.js before the
    // section JS, so in practice we retry zero times — the bound is a
    // safety net for the embla.js-failed-to-load case (CDN 404 after a
    // theme asset rotation, network interruption, etc.).
    const INIT_MAX_FRAMES = 120;
    function initAll(attempt) {
      if (typeof window.EmblaCarousel !== 'function') {
        if ((attempt || 0) >= INIT_MAX_FRAMES) {
          console.warn('[tizz-social-wall] embla.js did not load within ' + INIT_MAX_FRAMES + ' frames — carousel disabled.');
          return;
        }
        // setTimeout (not RAF) for the retry: RAF can be skipped or
        // throttled in some embedded browsers/headless contexts where
        // there's no paint pressure, leaving the chain dead. setTimeout
        // ~16ms is functionally a frame and always fires.
        setTimeout(() => initAll((attempt || 0) + 1), 16);
        return;
      }
      document.querySelectorAll('[data-tizz-social-wall]').forEach(initWall);
    }

    // Pad rails IMMEDIATELY (independent of Embla load), so by the time
    // Embla initializes the rail already has enough width for loop:true
    // to engage. This sidesteps the embla.js-load timing path.
    function padAllRails() {
      document.querySelectorAll('[data-tizz-social-wall]').forEach(function (wall) {
        const viewport = wall.querySelector('[data-tizz-social-viewport]');
        const rail = wall.querySelector('[data-tizz-social-rail]');
        if (viewport && rail) padRailForLoop(rail, viewport);
      });
    }

    // Wrap initAll so it starts at attempt 0 regardless of the caller.
    // ready() can pass a DOMContentLoaded Event, and section:load always
    // passes one — feeding an Event into the retry counter would bypass
    // the 120-frame bail on the embla.js-404 path.
    const startInit = () => {
      // Pad rails BEFORE Embla init so loop:true engages — Embla's loop
      // is silently disabled when the rail can't span ~2x the viewport.
      padAllRails();
      initAll(0);
    };
    ready(startInit);
    document.addEventListener('shopify:section:load', startInit);
    document.addEventListener('shopify:section:unload', (e) => {
      const wall = e.target.querySelector?.('[data-tizz-social-wall]');
      if (wall) destroyWall(wall);
    });

    function destroyWall(wall) {
      const prev = instances.get(wall);
      if (prev) { prev.destroy(); instances.delete(wall); }
    }

    // Pad the rail with cloned slides until total rail width is ≥ ~2.1x
    // the viewport width. Embla silently disables loop:true when the
    // rail can't span 2x the viewport (its internal cloning math needs
    // headroom), which leaves dead space at the end of the carousel
    // instead of a seamless wrap. This typically only triggers on
    // desktop where 4 cards visible × 5 cards total = 1.2x ratio;
    // mobile (~1.4 cards visible × 5 total) already exceeds 2x.
    //
    // Idempotent: prior clones (tagged data-tizz-clone) are stripped
    // first, so this is safe across shopify:section:load re-inits.
    function padRailForLoop(rail, viewport) {
      rail.querySelectorAll('[data-tizz-clone="true"]').forEach((el) => el.remove());

      const viewportW = viewport.getBoundingClientRect().width;
      if (viewportW === 0) return;

      const originals = Array.from(rail.children);
      if (originals.length === 0) return;

      const targetW = viewportW * 2.1;
      const safetyMax = originals.length * 6;
      let i = 0;
      while (rail.scrollWidth < targetW && i < safetyMax) {
        const src = originals[i % originals.length];
        const clone = src.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-tizz-clone', 'true');
        // Strip unique IDs so screen-reader label-for refs remain valid
        // on the originals only.
        if (clone.id) clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        rail.appendChild(clone);
        i++;
      }
    }

    function initWall(wall) {
      destroyWall(wall);

      const viewport = wall.querySelector('[data-tizz-social-viewport]');
      const rail = wall.querySelector('[data-tizz-social-rail]');
      const prev = wall.querySelector('[data-tizz-social-prev]');
      const next = wall.querySelector('[data-tizz-social-next]');

      if (!viewport || !rail) return;

      const slideCount = rail.children.length;
      if (slideCount === 0) return;

      // Run BEFORE the play-handler binding below so the cloned cards'
      // play buttons get handlers too.
      padRailForLoop(rail, viewport);
      // Force a synchronous layout pass so Embla measures the (now-padded)
      // rail correctly. Without this, Embla.init() can run with stale
      // measurements taken before the browser laid out the cloned slides,
      // resulting in slidesInView() returning 0 and the rail appearing
      // stuck even though scrollNext()/scrollPrev() advance the index.
      void rail.offsetWidth;

      // Click-to-play handlers (re-bind each init; old nodes are gone
      // after section:load replaces them).
      wall.querySelectorAll('[data-tizz-social-play]').forEach((btn) => {
        btn.addEventListener('click', () => playVideoIn(btn));
      });

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const autoplayEnabled = wall.dataset.tizzAutoplay === '1' && !reduceMotion;
      const delay = parseInt(wall.dataset.tizzAutoplayDelay, 10) || 4000;
      const plugins = [];
      if (autoplayEnabled && typeof window.EmblaCarouselAutoplay === 'function') {
        plugins.push(window.EmblaCarouselAutoplay({
          delay,
          stopOnInteraction: false,
          stopOnMouseEnter: true,
          stopOnFocusIn: true,
        }));
      }

      const embla = window.EmblaCarousel(viewport, {
        loop: true,
        align: 'start',
        containScroll: false,
        skipSnaps: false,
        dragFree: false,
        duration: reduceMotion ? 0 : 25,
      }, plugins);

      instances.set(wall, embla);

      // Belt-and-suspenders: re-measure after window.load (catches late
      // image/font layout that affected the cloned slides' widths).
      // Without this, Embla can hang on to stale measurements taken
      // before the browser laid out the cloned slides.
      if (document.readyState !== 'complete') {
        window.addEventListener('load', function () { embla.reInit(); }, { once: true });
      }

      // Wire video → autoplay only when the plugin is actually registered.
      // Without this guard we'd attach three listeners per video that only
      // invoke optional-chained no-ops. Merchant editor toggles re-run
      // initWall via shopify:section:load, so flipping autoplay on later
      // re-attaches these cleanly on the next init.
      if (plugins.length) {
        wall.querySelectorAll('video[data-tizz-social-video-el]').forEach((v) => {
          v.addEventListener('play', () => embla.plugins().autoplay.stop());
          v.addEventListener('pause', () => embla.plugins().autoplay.play());
          v.addEventListener('ended', () => embla.plugins().autoplay.play());
        });
      }

      // Arrow buttons live inside <section>, so shopify:section:load
      // replaces them outright — no old listeners to remove.
      if (prev) prev.addEventListener('click', () => embla.scrollPrev());
      if (next) next.addEventListener('click', () => embla.scrollNext());

      // If Embla silently disabled loop (e.g. fewer slides than fit the
      // viewport), disable arrows at each end so the user gets visual
      // feedback instead of a dead click.
      function syncArrowState() {
        if (!prev || !next) return;
        // internalEngine() is a semi-private Embla API. We use it to
        // detect whether loop was silently disabled (happens when slide
        // count is too low to fill the viewport). Re-check this line
        // when bumping embla.js — Embla reserves the right to reshape
        // engine internals between minor versions.
        if (embla.internalEngine().options.loop) {
          prev.removeAttribute('aria-disabled');
          next.removeAttribute('aria-disabled');
          return;
        }
        prev.toggleAttribute('aria-disabled', !embla.canScrollPrev());
        next.toggleAttribute('aria-disabled', !embla.canScrollNext());
      }
      embla.on('select', syncArrowState);
      embla.on('init', syncArrowState);
      embla.on('reInit', syncArrowState);
      syncArrowState();
    }

    function playVideoIn(btn) {
      // Guard against double-click: if already hidden, playback started.
      if (btn.hasAttribute('hidden')) return;

      const card = btn.closest('.tizz-social-card');
      if (!card) return;
      const video = card.querySelector('[data-tizz-social-video-el]');
      if (!video) return;

      video.querySelectorAll('source[data-src]').forEach((src) => {
        src.src = src.dataset.src;
        src.removeAttribute('data-src');
      });
      video.load();
      video.removeAttribute('hidden');
      video.controls = true;
      video.muted = false;
      btn.setAttribute('hidden', '');
      // Move focus to the now-visible video — keyboard users must land on
      // the native controls, not the now-hidden play button.
      video.focus();

      const p = video.play();
      if (p && typeof p.then === 'function') {
        p.catch(() => {
          // Autoplay-policy fallback: browsers may refuse unmuted play.
          video.muted = true;
          video.play().catch(() => {});
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tizz-video-panel"] && !Shopify.designMode) return;
  try {
    
(function() {
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var registry = new WeakMap();

  function initSection(section) {
    if (registry.has(section)) return;
    var video = section.querySelector('.tizz-video-panel__video');
    if (!video) return;
    var soundBtn = section.querySelector('.tizz-video-panel__sound');
    var playBtn = section.querySelector('.tizz-video-panel__play');

    function applyReducedMotion() {
      if (reducedMotionQuery.matches) {
        video.removeAttribute('autoplay');
        video.pause();
        if (playBtn) playBtn.hidden = false;
      } else if (playBtn) {
        playBtn.hidden = true;
      }
    }

    applyReducedMotion();

    if (reducedMotionQuery.addEventListener) {
      reducedMotionQuery.addEventListener('change', applyReducedMotion);
    } else if (reducedMotionQuery.addListener) {
      reducedMotionQuery.addListener(applyReducedMotion);
    }

    if (playBtn) {
      playBtn.addEventListener('click', function() {
        video.play().then(function() {
          playBtn.hidden = true;
        }).catch(function() {});
      });
    }

    if (soundBtn) {
      soundBtn.addEventListener('click', function() {
        var wasMuted = video.muted;
        var justUnmuted = wasMuted;
        video.muted = !wasMuted;
        soundBtn.setAttribute('aria-pressed', justUnmuted ? 'true' : 'false');
        soundBtn.setAttribute('aria-label', justUnmuted ? 'Mute video' : 'Unmute video');
        var icon = soundBtn.querySelector('.tizz-video-panel__sound-icon');
        if (icon) icon.textContent = justUnmuted ? '🔊' : '🔈';
        if (justUnmuted) {
          video.play().catch(function() {});
        }
      });
    }

    var observer = null;
    var loadObserver = null;
    if ('IntersectionObserver' in window) {
      // One-shot load-ahead: the markup has preload="none" and no autoplay,
      // so nothing buffers at page load. Fetch the film once the section is
      // within ~600px of the viewport so playback starts without a stall.
      // Skipped under reduced motion — those users get click-to-play, and
      // play() fetches on demand.
      loadObserver = new IntersectionObserver(function(entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          loadObserver.disconnect();
          // Tile before the motion guard: the background is static
          // decoration, so reduced-motion users get it too.
          section.classList.add('tvp-tile-ready');
          if (!reducedMotionQuery.matches) video.load();
          break;
        }
      }, { rootMargin: '600px 0px' });
      loadObserver.observe(section);

      observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (reducedMotionQuery.matches) return;
          if (entry.isIntersecting) {
            video.play().catch(function() {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.25 });
      observer.observe(section);
    } else {
      section.classList.add('tvp-tile-ready');
      if (!reducedMotionQuery.matches) {
        // The removed autoplay attribute used to cover no-IO browsers.
        video.play().catch(function() {});
      }
    }

    registry.set(section, { observer: observer, loadObserver: loadObserver, mediaListener: applyReducedMotion });
  }

  function destroySection(section) {
    var state = registry.get(section);
    if (!state) return;
    if (state.observer) state.observer.disconnect();
    if (state.loadObserver) state.loadObserver.disconnect();
    if (state.mediaListener) {
      if (reducedMotionQuery.removeEventListener) {
        reducedMotionQuery.removeEventListener('change', state.mediaListener);
      } else if (reducedMotionQuery.removeListener) {
        reducedMotionQuery.removeListener(state.mediaListener);
      }
    }
    registry.delete(section);
  }

  document.querySelectorAll('.tizz-video-panel').forEach(initSection);

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target.querySelector('.tizz-video-panel');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function(e) {
    var section = e.target.querySelector('.tizz-video-panel');
    if (section) destroySection(section);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
